/**
 * Dashboard
 */

'use strict';

// Constructor
var FrontDashboard = function () {
    if (!$('body').hasClass('dashboard')) {
        return;
    }

    $(document).ready((function () {
        this.computeUiElementsPosition();
    }).bind(this));
};

FrontDashboard.prototype = {
    lockAjaxForm: false,

    computeUiElementsPosition: function () {
        $('.dashboard select').formSelect();

        $('.dashboard .actors-chips').chips();

        // Equal columns heights for entry-content and sidebar

        $('main#content > .col').matchHeight();
        $.fn.matchHeight._maintainScroll = true;

        // Sidebar menu tooltips
        // Bug fix for MaterializeCSS

        $(window).on('resize scroll', function() {
            var headerMargin = $('#site-header').css('margin-bottom');

            $('aside#links .tooltipped').each(function() {
                var id = $(this).data('tooltip-id');
                if (headerMargin != '0px') {
                    $('#' + id).css('margin-top', '-' + headerMargin);
                } else {
                    $('#' + id).css('margin-top', '0px');
                }
            });
        });
    },
};

module.exports = new FrontDashboard();
